import React, { createContext, useEffect, useState } from 'react';
import { useHttpUtils } from '../Utilities/useHttpUtils';

interface ConfigurationContextInterface {
    configurationData: any
}

const ConfigurationContext = createContext<ConfigurationContextInterface>({
    configurationData: {}
});

interface ConfigurationContextProviderProps {
    children: React.JSX.Element
}

export const ConfigurationProvider = ({ children }: ConfigurationContextProviderProps) => {

    const { fetchDataAuthenticated } = useHttpUtils();
    const [configurationData, setConfigurationData] = useState();

    useEffect(() => {
        fetchDataAuthenticated("api/v1/configurationData")
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error();
            })
            .then(data => {
                setConfigurationData(data);
            })
            .catch(() => {
                console.log("Failed to retrieve configuration data");
            });
    }, [fetchDataAuthenticated]);

    return (
        <ConfigurationContext.Provider value={{ configurationData }}>
            {children}
        </ConfigurationContext.Provider>
    );
};

export default ConfigurationContext;